<template>
    <page showBackButton>
        <h2>Diese Seite ist geschützt.</h2>
        <br />
        Bitte gib das richtige Passwort ein und klicke auf Weiter:
        <base-input
            label="Passwort"
            v-model="password"
            type="password"
            id="passwort"
            @keyup.enter.native="validateBeforeSubmit()"
            class="ion-margin-bottom"
        ></base-input>
        <ion-button expand="block" @click="validateBeforeSubmit"
            >Weiter</ion-button
        >
    </page>
</template>

<script>
import Page from "@/components/Page";
import { checkPageAccess } from "@/utils";
import BaseInput from "@/components/BaseInput";

export default {
    components: {
        Page,
        BaseInput,
    },
    data() {
        return {
            password: "",
        };
    },
    mounted() {
        // const ppw = sessionStorage.getItem("ppw");
        // if (ppw !== null) {
        //     this.password = ppw;
        // }
    },
    methods: {
        validateBeforeSubmit() {
            checkPageAccess(this.$route.query.page, this.password).then(
                (value) => {
                    if (value) {
                        sessionStorage.setItem("ppw", this.password);
                        this.$router.push(this.$route.query.page);
                    } else {
                        this.$ionic.alertController
                            .create({
                                header: "Fehler",
                                message:
                                    "Das Passwort ist nicht korrekt. Bitte versuche es noch einmal",
                                buttons: ["Ok"],
                            })
                            .then((a) => {
                                a.present();
                            });
                    }
                }
            );
        },
    },
};
</script>

<style></style>
